<template>
  <div class="form-wrapper">
    <form @submit="handleSubmit">
      <label for="user-id">User ID</label>
      <input
        id="user-id"
        v-model="userID"
        autofocus
        placeholder="Enter user id or email"
        required
        type="text"
        class="border-2"
      />
      <button
        v-if="!showDatePicker"
        class="p-3 shadow-md px-12 rounded-full mt-6 border-none text-white font-bold bg-green"
      >
        Get FullStory Details
      </button>
    </form>
    <form v-if="showDatePicker" @submit="handleUpdate">
      <label for="fullstory-date">FullStory Date</label>
      <EdystDatePicker
        id="fullstory-date"
        v-model="fullStoryDate"
        :selected="fullStoryDate"
      />
      <button class="button-green link">Update FullStory Details</button>
    </form>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import EdystDatePicker from "@/components/ReactDatePicker/DatePicker"

export default {
  components: {
    EdystDatePicker,
  },
  data() {
    return {
      userID: "",
      userPreferences: undefined,
      showDatePicker: false,
      fullStoryDate: undefined,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.getPreferences()
    },
    handleUpdate(e) {
      e.preventDefault()
      if (!this.userPreferences) {
        this.userPreferences = {}
      }
      this.userPreferences.record_session_until_date = this.fullStoryDate
      this.updatePreferences()
    },
    getPreferences() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/user_preferences?user_id=${this.userID}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.userPreferences = res.data.preferences
          if (
            this.userPreferences &&
            Object.prototype.hasOwnProperty.call(
              this.userPreferences,
              "record_session_until_date"
            )
          ) {
            this.fullStoryDate = new Date(
              this.userPreferences.record_session_until_date
            )
          }
          this.showDatePicker = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    updatePreferences() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/user_preferences`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { user_id: this.userID, preferences: this.userPreferences },
      })
        .then(() => {
          this.$noty.success("Successfully updated user fullstory!", {
            layout: "topRight",
            theme: "relax",
          })
        })
        .catch(() => {
          this.$noty.error("Failed update user fullstory!", {
            layout: "topRight",
            theme: "relax",
          })
        })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  /* text-align: center; */
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
button {
  display: block;
  margin: 10px auto;
  text-align: center;
}
</style>
